export const CANCELLATION_REVIEW_PENDING =
  "CANCELLATION_REVIEW_PENDING" as const;

type WorkHoldTask = {
  cancellationReviewPending?: boolean;
  displayStatus?: string;
  workHold?: { code?: string } | null;
};

export function isTaskHeld(task: WorkHoldTask): boolean {
  return (
    task.cancellationReviewPending === true ||
    task.displayStatus === "ON_HOLD" ||
    task.workHold?.code === CANCELLATION_REVIEW_PENDING
  );
}

export function cancellationHoldError(error: unknown): {
  isHold: boolean;
  heldTaskIds: string[];
} {
  const data = (
    error as {
      response?: { data?: { code?: unknown; heldTaskIds?: unknown } };
    }
  )?.response?.data;
  return {
    isHold: data?.code === CANCELLATION_REVIEW_PENDING,
    heldTaskIds: Array.isArray(data?.heldTaskIds)
      ? data.heldTaskIds.filter(
          (taskId): taskId is string => typeof taskId === "string"
        )
      : [],
  };
}

export function cancellationReviewCopy(status: string): string {
  if (status === "IN_PROGRESS") {
    return "Stop forward handoff. Keep the package secure and contact dispatch for instructions. If the request is rejected, this task resumes; approval cancels the work.";
  }
  return "Do not start this task. Continue unrelated work and wait for dispatch. If the request is rejected, this task resumes; approval cancels the work.";
}
